import { Icon } from '../../Icon2';
import React from 'react';
import { Button } from '../../Button';

interface Props {
  icon: string;
  iconColor?: string;
  className?: string;
  onKeyboardAction?: (event: React.KeyboardEvent<HTMLButtonElement>) => void;
  onPressAction?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  label: string;
}

const ENTER = 13;
const SPACE = 32;

export function NavigationButton({
  icon,
  onKeyboardAction,
  onPressAction,
  className,
  disabled,
  label
}: Props) {
  function handleKeyDown(event: React.KeyboardEvent<HTMLButtonElement>) {
    if (event.keyCode === ENTER || event.keyCode === SPACE) {
      onKeyboardAction?.(event);
    }
  }
  return (
    <Button
      onClick={onPressAction}
      onKeyDown={handleKeyDown}
      disabled={disabled}
      className={className}
      aria-label={label}
      variant="carouselNavigation"
    >
      <Icon icon={icon} />
    </Button>
  );
}
